import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION;

export const getTransportPdfData = createAsyncThunk(
  'stop/getTransportPdfData',
  async (params) => {
    const { transportUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION,
      },
    };
    const response = await axios
      .get(transportUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const transportPdfSlice = createSlice({
  name: 'stop/transportPdf',
  initialState: null,
  reducers: {
    resetTransportPdf: () => null,
  },
  extraReducers: {
    [getTransportPdfData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetTransportPdf } = transportPdfSlice.actions;

export default transportPdfSlice.reducer;
